import { NavTabsContainer } from 'altus-ui-components';
import SystemRoutesContainer from 'app/components/SystemRoutesContainer';
import { toRiskManagement } from 'utils/route.util';
import { Grid, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import BackButton from 'app/components/BackButton';
import { useTheme } from '@material-ui/core/styles';
import { useLocation } from 'react-router';
import { useEffect } from 'react';
import { getIntegrityRuleDetails } from 'features/settings/integrityManagement/helpers/integrityManagement.actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { getSelectedIntegrityRule } from 'features/settings/integrityManagement/helpers/integrityManagement.selectors';

const IntegrityDetailsContainer = ({
  routes,
  fieldId,
  wellboreId,
  dispatchGetRuleDetails,
  integrityId,
  selectedRule,
}) => {
  const history = useHistory();
  const theme = useTheme();
  const location = useLocation();
  const showTabs =
    location.pathname.includes('attachments') ||
    location.pathname.includes('history');

  useEffect(() => {
    if (integrityId) dispatchGetRuleDetails(integrityId);
  }, [integrityId, dispatchGetRuleDetails]);

  return (
    <>
      <Grid container spacing={2} style={{ padding: theme.spacing(2) }}>
        <Grid item>
          <BackButton
            onClick={() => history.push(toRiskManagement(fieldId, wellboreId))}
          />
        </Grid>
        <Grid item>
          <Typography variant="h6" align="left">
            {selectedRule && selectedRule.title}
          </Typography>
        </Grid>
      </Grid>
      {showTabs && <NavTabsContainer routes={routes} />}
      {<SystemRoutesContainer routes={routes} />}
    </>
  );
};

export default compose(
  connect(
    (state) => ({
      selectedRule: getSelectedIntegrityRule(state),
    }),
    {
      dispatchGetRuleDetails: getIntegrityRuleDetails,
    },
  ),
)(IntegrityDetailsContainer);
